import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/science.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const MscZoology = () => {
    return (
        <div className='  w-full relative font-poppins ' >
            <Title canonicalPath="/programmes/ug-courses/sciences/msc/zoology
" />
            <Title title="M.Sc. in Zoology at Maya Devi University, Dehradun" description="Join the M.Sc. in Zoology program at MDU, Dehradun. Advance your understanding of animal sciences and pursue a career in research and conservation." />
            <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
                <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>M.Sc. Zoology</h2>
                <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                    <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' alt='Student in a bio lab' />
                    <div className=' flex flex-col gap-4 ' >
                        <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                        <p className=' text-justify md:text-md ' >Master of Science (M.Sc.) in Zoology is a full time one year/two year programme that gives a deep insight into the study of animals, their behavior, physiology, ecology, evolution, and conservation. Zoology is a broad field, encompassing everything from microscopic organisms to complex vertebrates, and it intersects with various other disciplines such as ecology, genetics, physiology, and evolutionary biology. The curriculum also includes practical training through laboratory work, fieldwork, and research projects.
                            <br /><br />
                            The Department of Zoology is the constituent entity of School of Applied Sciences. It has been the  foremost centre in advancing the understanding of the animal kingdom & its diversity and training the next generation of scientists and professionals dedicated to the study and conservation of animals and their habitats.
                            <br /><br />
                            The Department is nourished with dynamic faculty members who are actively engaged in teaching and learning process. The Department has been holding various workshops, symposia, conferences and other teaching courses to provide a platform for scientific exchanges from time to time. It is a well recognized department having all the necessary facilities like spacious laboratories, a well-stocked Zoology Museum, an exclusive research laboratory and smart classes.</p>
                        <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
                    <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>B.Sc. with Zoology as one of the subjects studied in all three years with not less than 50% marks in aggregate and not less than 50% marks in Zoology</p>
                    </div>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <p>After completion of the program, the students have:</p>
                    <ul className=' list-disc ' >
                        <li>Students gain knowledge and skills in the fundamentals of animal sciences and understand the complex interactions among various organisms.</li>
                        <li>Analyze complex interactions among the various animals of different phyla, their distribution, and their relationship with the environment.</li>
                        <li>Educate students to be responsible and productive science students.</li>
                        <li>Develop the skills and knowledge to effectively apply emerging technologies to meet future challenges.</li>
                        <li>Prepare students to make a positive contribution to their community and society.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>This course gives Zoologists a chance to develop their knowledge and communication skills and apply critical thinking that would help them to interpret scientific data collected from various sources. This skill set is always a boon to scientific researchers. One can apply in government and private colleges/universities to pursue their  teaching carrier. One can go for jobs in prominent national organizations like  Zoological Survey of India, wild life institute or work in areas such as poultry farming, sericulture, or pisciculture. Along with these fields, teaching, government exams, and research are also some viable options.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <p>After completing a Master of Science in Zoology, there are different career options available:</p>
                    <ul className=' list-disc ' >
                        <li>Scientist</li>
                        <li>Academician</li>
                        <li>Entomologist</li>
                        <li>Conservation Officer</li>
                        <li>Wildlife Biologist</li>
                        <li>Environmental Consultant</li>
                        <li>Ecologist</li>
                        <li>Animal Nutritionist</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 mt-[20px] mb-[30px] ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>USPs</h4>
                    <ul className=' list-disc ' >
                        <li>Highly qualified faculty with a strong commitment to teaching & research.</li>
                        <li>Choice Based Credit System (CBCS) Based Assessments and Evaluation.</li>
                        <li>Dissertation in the final year to garnish basic research experience.</li>
                        <li>Advanced Diagnostic & Mentoring for Career and Placement throughout the Course.</li>
                        <li>Field Activities to study fauna.</li>
                        <li>Interactive linkage with leading industries and academic institutions.</li>
                    </ul>
                </div>

                {/* table */}
                <div className="flex flex- mb-[100px] ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Programme</th>
                                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Master of Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Zoology</td>
                                            <td className="whitespace-nowrap  px-6 py-4">2</td>
                                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default MscZoology